import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { OpenTradeAccountParameter } from "@tSurya/Services/SubmitOpenTradeService";
import { OpenTradeAccountState } from "@tSurya/Store/Data/SurOpenTradeAccountState";
import { Draft } from "immer";

const initialState: OpenTradeAccountState = {
    isLoading: false,
    companyData: null,
    updatedCustomerData: null,
    attachments: undefined,
};

const reducer = {
    "Custom/OpenTradeAccount/BeginOpenTradeAccount": (draft: Draft<OpenTradeAccountState>) => {
        draft.isLoading = true;
    },
    "Custom/OpenTradeAccount/CompletedOpenTradeAccount": (
        draft: Draft<OpenTradeAccountState>,
        action: { result: OpenTradeAccountParameter },
    ) => {
        draft.isLoading = false;
        draft.companyData = { ...draft.companyData, ...action.result };
    },
    "Custom/OpenTradeData/ClearSubmitOpenTrade": (draft: Draft<OpenTradeAccountState>) => {
        draft.isLoading = false;
        // draft.companyData = null;
        if (
            draft.companyData?.BillingInformation &&
            draft.companyData?.BusinessOverview &&
            draft.companyData?.CompanyInformation
        ) {
            draft.companyData.BillingInformation = null;
            draft.companyData.BusinessOverview = null;
            draft.companyData.CompanyInformation = null;
        }
    },
    // "Custom/OpenTradeAccount/AddNewFile": (
    //     draft: Draft<OpenTradeAccountState>,
    //     action: { result: OpenTradeAccountParameter },
    // ) => {
    //     draft.attachments = [...draft.attachments, ...(<[]>action.result)];
    // },

    // "Custom/OpenTradeAccount/DeleteFile": (draft: Draft<OpenTradeAccountState>, action: { result: any[] }) => {
    //     draft.attachments = [...action.result];
    //     /*
    //     fetch all the file from reducer  -> [1,2,3,4]
    //     delete 2nd file or anyfile -> [4]
    //     send the rest of the data back to reducer -> [1,2,3,5]
    //     */
    // },
    "Custom/OpenTradeData/BeginSubmitOpenTrade": (draft: Draft<OpenTradeAccountState>) => {
        draft.isLoading = true;
    },
    "Custom/OpenTradeData/CompletedSubmitOpenTrade": (
        draft: Draft<OpenTradeAccountState>,
        action: { result: OpenTradeAccountParameter },
    ) => {
        draft.isLoading = false;
        draft.companyData = { ...draft.companyData, ...action.result };
    },
    "Custom/OpenTradeData/FailedSubmitOpenTrade": (draft: Draft<OpenTradeAccountState>) => {
        draft.isLoading = false;
    },
    "Custom/UpdateOpenTradeData/BeginUpdateOpenTrade": (draft: Draft<OpenTradeAccountState>) => {
        draft.isLoading = true;
    },
    "Custom/UpdateOpenTradeData/CompletedUpdateOpenTrade": (
        draft: Draft<OpenTradeAccountState>,
        action: { result: OpenTradeAccountParameter },
    ) => {
        draft.isLoading = false;
        draft.updatedCustomerData = action.result;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
